import Vue from 'vue'
import VueRouter from 'vue-router'

import routes from './routes.js'
import i18n from '../i18n.js'

Vue.use(VueRouter)

const router = new VueRouter({
  routes,
  linkActiveClass: 'is-active'
})

router.beforeEach((to, from, next) => {
  if (to.meta.lang) {
    i18n.locale = to.meta.lang
  }

  window.scrollTo(0, 0)
  next()
})

router.afterEach(() => {
  // Prevent user disorientation
  document.body.scrollTop = 0
})

export default router
